// Ekran 03 — §6.3 bantlarının istemci ikizi.
//
// Neden burada: fermenter formu değer GİRİLİRKEN rozet gösteriyor (ref:763-769),
// yani kayıt sunucuya gitmeden bant hesaplanmalı. Kural
// `Btys.Domain/Calc/EsikBandi.cs` ile birebir aynı tutuldu; eşik SAYILARI
// koda gömülmüyor, `ayar_esik`'ten `GET /api/numuneler/ozet` ile geliyor
// (§8-14: eşik değişince bant anında değişmeli).

import type { Bant, EsikDto } from './api'

/** Üst sınırlı gösterge: amber'i geçerse izle, kırmızıyı geçerse kritik. */
export function ustSinir(deger: number | null, esik: EsikDto | undefined): Bant {
  if (deger === null || !esik) return 'saglikli'
  if (esik.kirmizi !== null && deger > esik.kirmizi) return 'kritik'
  if (esik.amber !== null && deger > esik.amber) return 'izle'
  return 'saglikli'
}

/** Aralık göstergesi (pH): sağlıklı aralık içi yeşil, izle aralığı amber, dışı kırmızı. */
export function aralik(
  deger: number | null,
  saglikliAralik: EsikDto | undefined,
  izleAraligi: EsikDto | undefined,
): Bant {
  if (deger === null || !saglikliAralik) return 'saglikli'
  if (icinde(deger, saglikliAralik)) return 'saglikli'
  if (izleAraligi && icinde(deger, izleAraligi)) return 'izle'
  return 'kritik'
}

function icinde(deger: number, e: EsikDto): boolean {
  return (
    (e.normalMin === null || deger >= e.normalMin) &&
    (e.normalMax === null || deger <= e.normalMax)
  )
}

/**
 * Göstergenin kalıbına göre doğru kuralı seçer. pH iki taraflı olduğu için
 * "izle" aralığını ayrı satırdan (`ph_izle`) okur — şema kararının aynısı.
 */
export function bant(
  esikler: EsikDto[] | undefined,
  gosterge: string,
  deger: number | null,
): Bant {
  if (deger === null) return 'saglikli'
  const bul = (ad: string) => esikler?.find((e) => e.gosterge === ad)
  const satir = bul(gosterge)
  if (!satir) return 'saglikli'
  return satir.kalip === 'aralik'
    ? aralik(deger, satir, bul(`${gosterge}_izle`))
    : ustSinir(deger, satir)
}

/** Rozet metni — sunucudaki `EsikBandi.Etiket` ile aynı. */
export const BANT_ETIKET: Record<Bant, string> = {
  saglikli: 'sağlıklı',
  izle: 'izle',
  kritik: 'kritik',
}
